import React, { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { toast } from "sonner";
import api from "../../../../lib/api";

export function WhatsAppCard() {
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/whatsapp/status").then((r) => setSt(r.data)).catch(() => {}); }, []);
  if (!st) return null;
  const test = async () => {
    setBusy(true);
    try { await api.post("/admin/whatsapp/test"); toast.success("تم إرسال رسالة تجريبية إلى واتساب"); }
    catch (e) { toast.error(e.response?.data?.detail || "فشل الإرسال"); }
    finally { setBusy(false); }
  };
  return (
    <div data-testid="whatsapp-card" className="border border-[#262421] p-5 mb-8 flex items-center justify-between gap-4 flex-wrap">
      <div className="flex items-center gap-3">
        <MessageCircle size={18} className={st.configured ? "text-[#7FB77E]" : "text-[#8A857D]"} />
        <div>
          <p className="text-sm" data-testid="whatsapp-status-text">
            {st.configured ? `تنبيهات واتساب مفعّلة · ****${st.to}` : "تنبيهات واتساب غير مفعّلة"}
          </p>
          {!st.configured && <p className="text-[11px] text-[#8A857D] mt-1" dir="ltr">{st.missing.join(" · ")}</p>}
        </div>
      </div>
      <button onClick={test} disabled={!st.configured || busy} data-testid="whatsapp-test-btn"
        className="border border-[#C49A6C] text-[#C49A6C] text-xs uppercase tracking-[0.18em] px-5 py-3 hover:bg-[#C49A6C] hover:text-[#0B0A08] transition-colors disabled:opacity-40">
        {busy ? "جارٍ الإرسال…" : "إرسال رسالة تجريبية"}
      </button>
    </div>
  );
}
